import Vue from 'vue';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

import {
  CompaniaListMaestro,
  DistritoMaestro,
  ListMaestro,
  MotivosListMaestro,
  RoleModel,
  SelectModel
} from '@/models/file-entities.model';
import { StatusOption } from '@/models/file-app.model';

import { httpClient } from '../../core';
import i18n from '@/plugins/i18n';

import { optionsStatusList } from '@/business/settings';
const translate = (message: string) => i18n.t(message).toString();

export interface BasicDataState {
  optionsInternalRoles: RoleModel[];
  optionsRoles: RoleModel[];
  optionsExternalRoles: RoleModel[];
  optionsCompanies: SelectModel[];
  optionsDistritos: DistritoMaestro[];
  optionsAlcances: ListMaestro[];
  optionsAnomalias: ListMaestro[];
  optionsLotes: ListMaestro[];
  optionsUsuarios: ListMaestro[];
  optionsMotivos: MotivosListMaestro[];
  optionsTraslados: CompaniaListMaestro[];
  isLoadingBasicData: boolean;
}
export const state: BasicDataState = {
  optionsRoles: [],
  optionsInternalRoles: [],
  optionsExternalRoles: [],
  optionsCompanies: [],
  optionsDistritos: [],
  optionsAnomalias: [],
  optionsAlcances: [],
  optionsLotes: [],
  optionsUsuarios: [],
  optionsMotivos: [],
  optionsTraslados: [],
  isLoadingBasicData: false
};
export const getters: GetterTree<BasicDataState, any> = {
  optionsStatus(): StatusOption[] {
    const translatedList = optionsStatusList;
    translatedList.forEach(item => {
      item.name = translate(item.name);
    });
    return translatedList;
  }
};

export const mutations: MutationTree<BasicDataState> = {
  setIsLoadingBasicData(state, value) {
    state.isLoadingBasicData = value;
  },
  setOptionsRoles(state, value) {
    state.optionsRoles = value;
  },
  setOptionsInternalRoles(state, value) {
    state.optionsInternalRoles = value;
  },
  setOptionsExternalRoles(state, value) {
    state.optionsExternalRoles = value;
  },
  setOptionsCompanies(state, value) {
    state.optionsCompanies = value;
  },
  setOptionsDistritos(state, value) {
    state.optionsDistritos = value;
  },
  setOptionsLotes(state, value) {
    state.optionsLotes = value;
  },
  setOptionsUsuarios(state, value) {
    state.optionsUsuarios = value;
  },
  setOptionsMotivos(state, value) {
    state.optionsMotivos = value;
  },
  setOptionsTraslado(state, value) {
    state.optionsTraslados = value;
  },
  setOptionsAlcances(state, value) {
    state.optionsAlcances = value;
  },
  setOptionsAnomalia(state, value) {
    state.optionsAnomalias = value;
  }
};
export const actions: ActionTree<BasicDataState, any> = {
  getRoles: async ({ commit }) => {
    if (state.optionsRoles.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/roles';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsRoles', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.role_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getInternalRoles: async ({ commit }) => {
    if (state.optionsInternalRoles.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/roles/internal';

    const response = await httpClient().instance.get(route);
    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsInternalRoles', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.role_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getExternalRoles: async ({ commit }) => {
    if (state.optionsExternalRoles.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/roles/external';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsExternalRoles', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.role_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getCompanies: async ({ commit }) => {
    if (state.optionsCompanies.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/companies';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsCompanies', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.company_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getDistritos: async ({ commit }) => {
    if (state.optionsDistritos.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Maestro/Distritos';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsDistritos', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.distrito_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getLotes: async ({ commit }) => {
    if (state.optionsLotes.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Maestro/Lotes';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsLotes', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.lote_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getUsuarios: async ({ commit }) => {
    if (state.optionsUsuarios.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Maestro/Users';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsUsuarios', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.user_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },

  getMotivosCancelacion: async ({ commit }) => {
    if (state.optionsMotivos.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Maestro/MotivosCancelacion';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsMotivos', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.motivos_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getCompanias: async ({ commit }) => {
    if (state.optionsTraslados.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Maestro/Companies';

    const response = await httpClient().instance.get(route);

    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsTraslado', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.traslado_list';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },
  getAlcance: async ({ commit }) => {
    if (state.optionsAlcances.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Alcance/';

    const response = await httpClient().instance.get(route);
    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsAlcances', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.get_Alcance';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  },

  getAnomalia: async ({ commit }) => {
    if (state.optionsAnomalias.length > 0) return true;
    commit('setIsLoadingBasicData', true);
    const route = '/Anomalia/';

    const response = await httpClient().instance.get(route);
    commit('setIsLoadingBasicData', false);
    if (response && response.status === 200) {
      commit('setOptionsAnomalia', response.data);
      return response.data;
    } else {
      const messageError = 'response_error.get_Anomalia';
      Vue.$toast.error(translate(messageError));
      return false;
    }
  }
};

export const basicData: Module<BasicDataState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
